// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3xVM9","active":"NavigationItem_active__18mXT"};